/*
  vg-addons.js - behaviour for the "Build your machine" block.

  Two jobs:

  1. SPEC LADDERS. Memory and storage render as a row of sizes with the machine's
     shipped size first ("8GB - As listed"). Picking a size writes that variant
     id onto a visually hidden checkbox and ticks it; picking "As listed"
     unticks it. Everything downstream - `vg-addon-cart.liquid` adding the line,
     `vg-cart-guard.js` policing it - keys off that checkbox and needs no
     changes, which is the whole reason the ladder is built this way.

  2. RUNNING TOTAL. Sums every ticked add-on on the page, INCLUDING the warranty
     box, which lives in its own snippet but shares the `data-vg-addon` hook.
     Prices come from a variant id -> cents map rendered by the snippet, so no
     price is ever parsed back out of the DOM. The total is mirrored into
     Dawn's Add to cart button.

  Chip clicks and image/price swapping on the tick rows are NOT handled here -
  `vg-addon-cart.liquid` already owns those.
*/
(function () {
  var box = document.querySelector('[data-vg-addons]');
  if (!box) { return; }

  var PRICES = {};
  try { PRICES = JSON.parse(box.getAttribute('data-vg-prices') || '{}'); } catch (e) {}
  var BASE = Number(box.getAttribute('data-vg-base') || 0);

  function money(cents) {
    var n = Math.round(cents) / 100;
    var whole = n % 1 === 0;
    return '$' + n.toLocaleString('en-AU', {
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2
    });
  }

  /* ---------- spec ladders ---------- */

  function selectOption(btn) {
    var group = btn.closest('[data-vg-cfg]');
    if (!group) { return; }

    group.querySelectorAll('[data-vg-opt]').forEach(function (o) {
      o.setAttribute('aria-pressed', String(o === btn));
    });

    var cb = group.querySelector('[data-vg-addon]');
    if (!cb) { return; }
    var variant = btn.getAttribute('data-vg-var') || '';
    cb.value = variant;
    cb.checked = !!variant;
    /* let vg-addon-cart.liquid hide the instalments button as usual */
    cb.dispatchEvent(new Event('change', { bubbles: true }));
  }

  box.addEventListener('click', function (e) {
    var opt = e.target.closest ? e.target.closest('[data-vg-opt]') : null;
    if (!opt) { return; }
    e.preventDefault();
    selectOption(opt);
    refresh();
  });

  /* ---------- running total ---------- */

  var extrasEl = box.querySelector('[data-vg-extras]');
  var sumEl    = box.querySelector('[data-vg-sum]');
  var btnLabel = null;
  var btnBase  = '';

  (function findButton() {
    var btn = document.querySelector('form[action*="/cart/add"] .product-form__submit');
    if (!btn || btn.disabled) { return; }
    var span = btn.querySelector('span');
    if (!span) { return; }
    btnLabel = span;
    btnBase = span.textContent.trim();
  })();

  function extrasTotal() {
    var sum = 0;
    document.querySelectorAll('[data-vg-addon]').forEach(function (cb) {
      if (!cb.checked || !cb.value) { return; }
      var cents = PRICES[String(cb.value)];
      if (typeof cents === 'number') { sum += cents; }
    });
    return sum;
  }

  function refresh() {
    var extras = extrasTotal();
    if (extrasEl) { extrasEl.textContent = extras ? '+' + money(extras) : money(0); }
    if (sumEl)    { sumEl.textContent = money(BASE + extras); }
    if (btnLabel) {
      btnLabel.textContent = extras ? btnBase + ' · ' + money(BASE + extras) : btnBase;
    }
  }

  /* Any tick anywhere on the page - our rows, the warranty box - moves the total. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-vg-addon]')) { refresh(); }
  });

  /* Chip clicks change which variant a row will add, so re-price after
     vg-addon-cart.liquid has updated the checkbox value. */
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-vg-addon-swatch]')) {
      setTimeout(refresh, 0);
    }
  });

  if (document.readyState !== 'loading') { refresh(); }
  else { document.addEventListener('DOMContentLoaded', refresh); }
})();